import { video_watch_path } from '../routes';

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".lazyload").forEach(el => {
    lazyload(el);
  });

  document.querySelectorAll(".bg-lazyload").forEach(el => {
    lazyload(el, true);
  });
});

document.addEventListener('scroll', () => {
  document.querySelectorAll(".lazyload").forEach(el => {
    lazyload(el);
  });

  document.querySelectorAll(".bg-lazyload").forEach(el => {
    lazyload(el, true);
  });
});

function isElementVisible(element, offset = 500) {
    const rect = element.getBoundingClientRect();
    const top_of_element = rect.top + window.pageYOffset - offset;
    const bottom_of_element = top_of_element + rect.height + offset * 2;
    const top_of_screen = window.pageYOffset;
    const bottom_of_screen = top_of_screen + window.innerHeight;

    return (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
}

function lazyload(element, as_bg_image = false) {
  if (isElementVisible(element)) {
    var src = element.getAttribute('data-src');

    if (src) {
      if (as_bg_image) {
        element.style.backgroundImage = 'url("' + src + '")';
      } else {
        element.setAttribute('src', src);
      }
      
      element.removeAttribute('data-src');
    }

    if (element.nodeName === "IFRAME") {
      var player = new Vimeo.Player(element);

      player.on('timeupdate', function(data) {
        if (data.percent >= 0.75 && element.getAttribute('data-should-watch') === "true") {
          markVideoAsWatched(element);
        }
      });
    }
  }
}

function markVideoAsWatched(element) {
  var video_slug = element.getAttribute('data-video');
  var url = video_watch_path({ locale: window.I18n.locale, slug: video_slug });

  var csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
  
  fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrf_token,
      'Content-Type': 'application/json'
    }
  })
  .then(res => {
    if (res.ok) {
      if (window.toastr) {
        window.toastr.success(window.I18n.t('video.show.watched'));
      }
    } else {
      element.setAttribute('data-should-watch', 'true');
    }
  })
  .catch(function(err) {
    console.error('Error marking video as watched:', err);
    element.setAttribute('data-should-watch', 'true');
  });

  element.setAttribute('data-should-watch', 'false');
}
